export default __webpack_public_path__ + "static/beer-animation-e0fe36244672d266b19bbfd0afd2e4fe.gif";